
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import OptimizedImage from "@/components/OptimizedImage";
import type { Product } from "@/types/product";

interface ProductCardProps {
  product: Product;
}

const ProductCard = ({ product }: ProductCardProps) => {
  // Use slug URL if available, fall back to ID
  const productUrl = product.slug ? `/products/${product.slug}` : `/product/${product.id}`;
  const mainImage = product.images[0] || '/placeholder.svg';
  const formattedPrice = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
  }).format(product.price);

  return (
    <Card className="overflow-hidden h-full transition-all hover:shadow-md">
      <Link to={productUrl} className="block h-full">
        <AspectRatio ratio={4/3} className="overflow-hidden relative bg-muted">
          <OptimizedImage 
            src={mainImage} 
            alt={product.name} 
            className="object-contain w-full h-full transition-transform hover:scale-105"
          />
        </AspectRatio>
        <CardContent className="p-3 sm:p-4">
          <h3 className="font-medium text-sm sm:text-base mb-1 sm:mb-2 line-clamp-2">{product.name}</h3>
          <p className="font-bold text-sm sm:text-base">{formattedPrice}</p>
        </CardContent>
      </Link>
    </Card>
  );
};

export default ProductCard;
